import {Component, Input} from '@angular/core';
import {SequenceConfiguration} from '../../../../model/sequence-configuration';

@Component({
  selector: 'app-sequence-form-configuration-errors',
  templateUrl: './sequence-form-configuration-errors.component.html',
  styleUrls: ['./sequence-form-configuration-errors.component.scss']
})
export class SequenceFormConfigurationErrorsComponent {
  @Input() sequenceConfiguration: SequenceConfiguration;

  @Input() set errors(errors: any[]) {
    if (errors?.length !== 0) {
      this._errors = [];
      for (const error of errors) {
        this._errors.push({
          path: this.getPath(error),
          json: this.getJson(error),
          message: error.message
        });
      }
    }
  }

  _errors: { path: string, json: { [p: string]: any }, message: string }[];

  constructor() {
    this._errors = [];
  }

  public getPath(error: any): string {
    return error.property;
  }

  public getJson(error: any): { [p: string]: any } {
    const keys = error.property.split('.');
    const value: any = keys.reduce((acc: any, part: string): any => {
      const match: RegExpMatchArray = RegExp(/(\w+)\[(\d+)]/).exec(part);
      if (!match) {
        return acc?.[part];
      } else {
        const key: string = match[1];

        const index: number = parseInt(RegExp(/\d+/gm).exec(match[2]).toString());
        const value = acc?.[key];
        return value[index];
      }

    }, this.sequenceConfiguration);
    const lastKey: string = keys[keys.length - 1];
    return {[lastKey]: value};
  }
}
